import React, { useState } from 'react'
import { Search, Package } from 'lucide-react'
import DynamicIcon from '../DynamicIcon'

const IconPicker = ({ value, onChange, className = '' }) => {
  const [searchTerm, setSearchTerm] = useState('')

  const availableIcons = [
    'Smartphone', 'Star', 'Crown', 'Gem', 'Zap', 'Gift', 'Gamepad2', 
    'CreditCard', 'Globe', 'Sparkles', 'Trophy', 'Heart', 'Shield', 
    'Coins', 'Wallet', 'Package', 'Tag', 'Award', 'Diamond', 'Flame'
  ]

  const filteredIcons = availableIcons.filter(icon =>
    icon.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div className={className}>
      <div className="space-y-3">
        {/* Search */}
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-muted" />
          <input
            type="text"
            placeholder="Search icons..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="input pl-10"
          />
        </div>

        {/* Selected Icon Preview */}
        {value && (
          <div className="flex items-center space-x-2 p-3 bg-gray-50 rounded-lg">
            <DynamicIcon name={value} size={20} className="text-accent" />
            <span className="text-sm font-medium text-text-secondary">Selected: {value}</span>
          </div>
        )}

        {/* Icon Grid */}
        <div className="grid grid-cols-5 gap-2 max-h-48 overflow-y-auto">
          {filteredIcons.map(iconName => (
            <button
              key={iconName}
              type="button"
              onClick={() => onChange(iconName)}
              className={`
                flex flex-col items-center justify-center p-3 rounded-lg border transition-all
                hover:border-accent/50 hover:bg-accent/5
                ${value === iconName 
                  ? 'border-accent bg-accent/10 ring-2 ring-accent/20' 
                  : 'border-border'
                }
              `}
              title={iconName}
            >
              <DynamicIcon name={iconName} size={20} className="mb-1" />
              <span className="text-xs text-text-muted">{iconName}</span>
            </button>
          ))}
        </div>

        {filteredIcons.length === 0 && (
          <div className="text-center py-8 text-text-muted">
            <Package size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No icons found for "{searchTerm}"</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default IconPicker